export default function Provide(name, provider) {
  var cachedProvider = typeof provider === 'function' ? null : provider;
  return function (context) {
    context[name] = cachedProvider = cachedProvider || provider(context);

    if (context.debugger) {
      context.debugger.wrapProvider(name);
    }

    return context;
  };
}